import { defineApiInterceptor } from '@kouzoh/merpay-api-client';
import { Env } from '~/constants/env';
import { GATEWAY_PAT_HEADER_KEY, GATEWAY_MAT_COOKIE_KEY } from '~/constants/httpHeader';

export const createAuthInterceptor = (env: string, headers: Record<string, string>, mat: string) =>
  defineApiInterceptor({
    name: 'auth',
    onInit({ options }) {
      if (process.server) {
        if (env === Env.Local) {
          if (mat) {
            options.headers = {
              ...options.headers,
              Cookie: `${GATEWAY_MAT_COOKIE_KEY}=${mat}`,
            };
          }
        } else {
          const privateAccessTokenHeader = headers[GATEWAY_PAT_HEADER_KEY];
          const privateAccessToken = Array.isArray(privateAccessTokenHeader)
            ? privateAccessTokenHeader[0]
            : privateAccessTokenHeader;

          // set to Authorization header if privateAccessToken exist
          if (privateAccessToken) {
            options.headers = {
              ...options.headers,
              Authorization: privateAccessToken.replace(/^Bearer(\s)?/, ''),
            };
          }
        }
      }
    },
  });
